import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { trafficViolationService } from "services/trafficViolationService";
import { getEspelhoInfracaoTemplate } from "./Templates/espelhoInfracao";
import Loading from "components/Loading/Loading";

function generateHtmlTemplate(title, bodyContent) {
    return `
        <!DOCTYPE html>
        <html lang="pt-BR">
          <head>
            <meta charset="UTF-8">
            <title>${title}</title>
            <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@3.4.1/dist/css/bootstrap.min.css"
                  integrity="sha384-HSMxcRTRxnN+Bdg0JdbxYKrThecOKuH5zCYotlSAcp1+c8xmyTe9GYg1l9a69psu"
                  crossorigin="anonymous">
            <style>
                @media print {
                    @page { margin: 0; size: auto; }
                    body { margin: 0; }
                }
            </style>
          </head>
          <body onload="window.print();">
            <div id="timeline-container">
                ${bodyContent}
            </div>
          </body>
        </html>
    `;
}

export default function TrafficViolationTimelinePrintPage() {
    const { id } = useParams();
    const { t } = useTranslation();
    const [html, setHtml] = useState("");
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const load = async () => {
            try {
                const espelho = await trafficViolationService.espelho(id);
                const bodyContent = await getEspelhoInfracaoTemplate(espelho);
                setHtml(generateHtmlTemplate("Espelho da Infração", bodyContent));
            } catch (error) {
                const errorHtml = `
                    <div class="container" style="margin-top: 20px;">
                        <div class="alert alert-danger">
                            ${t("traffic-violation.details.tab-timeline.template-error-message", {
                                message: error?.message || t("traffic-violation.messages.errors.print-timeline")
                            })}
                        </div>
                    </div>
                `;
                setHtml(generateHtmlTemplate("Espelho da Infração — Erro", errorHtml));
            } finally {
                setIsLoading(false);
            }
        };

        load();
    }, [id, t]);

    return (
        <>
            {isLoading ? (
                <Loading maxH={{ sm: "100px", md: "350px" }} />
            ) : (
                <div dangerouslySetInnerHTML={{ __html: html }} />
            )}
        </>
    );
}
